/**
 * back-in-stock.js
 * Save this file as: assets/back-in-stock.js
 *
 * Handles opening/closing the right-side drawer and submitting
 * the notify-me form via fetch, so the customer gets an inline
 * "thank you" instead of a page reload.
 *
 * Replace with your deployed Cloudflare Worker URL:
 */
const WORKER_URL = 'https://back-in-stock-worker.dordnm.workers.dev';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-back-in-stock]').forEach(initBackInStock);
});

function initBackInStock(root) {
  const trigger = root.querySelector('[data-back-in-stock-open]');
  const drawer = root.querySelector('[data-back-in-stock-drawer]');
  const closeEls = root.querySelectorAll('[data-back-in-stock-close]');
  const form = root.querySelector('[data-back-in-stock-form]');
  const thankYou = root.querySelector('[data-back-in-stock-thankyou]');
  const emailInput = form.querySelector('input[type="email"]');

  const productId = root.dataset.productId;
  const productFormId = root.dataset.productFormId;

  // Watch the theme's real Add to Cart button so our visibility stays
  // correct as the shopper switches variants client-side (no page
  // reload happens on variant change, so we can't rely on the
  // Liquid-rendered `hidden` attribute alone after the first paint).
  const productFormEl = productFormId ? document.getElementById(productFormId) : null;
  const submitButton = productFormEl
    ? productFormEl.querySelector('button[type="submit"], .product-form__submit')
    : null;

  if (submitButton) {
    const syncVisibility = () => {
      root.hidden = !submitButton.disabled;
    };

    syncVisibility(); // correct any mismatch immediately on load

    const observer = new MutationObserver(syncVisibility);
    observer.observe(submitButton, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
  const variantId = root.dataset.variantId;

  // Move the drawer to <body> so `position: fixed` isn't trapped inside
  // an ancestor with a CSS transform (Dawn applies one for its
  // scroll-reveal animation on the product info column), which breaks
  // fixed positioning and can make the drawer render off-screen/clipped.
  document.body.appendChild(drawer);

  const overlay = drawer.querySelector('.back-in-stock__overlay');
  const panel = drawer.querySelector('.back-in-stock__panel');

  // Set base inline styles directly (not just via the <style> block) so
  // nothing in the theme's own stylesheet can accidentally override
  // this with a conflicting rule targeting a similarly-named class.
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.right = '0';
  overlay.style.bottom = '0';
  overlay.style.left = '0';

  overlay.style.zIndex = '1000';
  overlay.style.background = 'rgba(0, 0, 0, 0.4)';
  overlay.style.opacity = '0';
  overlay.style.pointerEvents = 'none';
  overlay.style.transition = 'opacity 0.3s ease';
  panel.style.zIndex = '1001';

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
    document.body.style.overflow = '';

    // Reset back to the form view so the next time this opens, it's
    // fresh rather than still showing the thank-you message.
    form.reset();
    form.hidden = false;
    thankYou.hidden = true;
    const submitBtn = form.querySelector('.back-in-stock__submit');
    submitBtn.disabled = false;
    submitBtn.textContent = 'NOTIFY ME';
  }

  trigger.addEventListener('click', openDrawer);
  closeEls.forEach((el) => el.addEventListener('click', closeDrawer));

  // Fallback: close whenever a click lands anywhere inside the drawer
  // that isn't inside the panel itself. This covers cases where the
  // overlay div's own click listener doesn't fire due to z-index or
  // pointer-events quirks from other page elements.
  drawer.addEventListener('click', (e) => {
    if (!panel.contains(e.target)) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const submitBtn = form.querySelector('.back-in-stock__submit');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';

    try {
      const response = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: emailInput.value,
          productId: productId,
          variantId: variantId,
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        form.hidden = true;
        thankYou.hidden = false;
      } else {
        throw new Error(result.error || 'Submission failed');
      }
    } catch (err) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Notify me';
      alert('Something went wrong. Please try again.');
    }
  });
}